export default "__VITE_ASSET__TVrepF7l__"